export default "__VITE_ASSET__DGdBGN6E__"